"use strict";
/**
 * What the primary market picker calls a market: the header button and the
 * list. A venue whose ids are unreadable sets
 * `Market.label` (Novig: its title); the rest keep the id-derived label.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketLabel = marketLabel;
/** Short label: the venue's own, else the id less its first segment (Kalshi's series). */
function marketLabel(market) {
    return market.label ?? market.id.replace(/^[^-]+-/, "");
}
